import React, { useEffect, useRef, useState } from 'react';
import { Typography, Tooltip } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import { useNavigate } from 'react-router';
import { getIconStatus } from 'src/app/utils/vehicleService';
import { showLoading } from 'src/features/videoSlice';
import { useDispatch } from 'react-redux';

const VehicleTableCell = props => {
  const { row, index, displayText } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const textRef = useRef(null);
  const [isOverflow, setIsOverflow] = useState(false);

  const isMoving = row.device_status === 'moving';

  const icon =
    row.debt === true
      ? '/static/iconSvg/motors/motor_expired.svg'
      : getIconStatus(row.device_status, row.vehicle_type);
  const iconCameraLive = isMoving
    ? `/static/iconSvg/video_motion_active.svg`
    : `/static/iconSvg/video_motion.svg`;

  const safeText =
    displayText && displayText.trim()
      ? displayText
      : row?.license_plate || '--';

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsOverflow(el.scrollWidth > el.clientWidth);
    }
  }, [safeText]);

  return (
    <Box
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '4px',
        paddingLeft: '3px'
      }}
    >
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}
      >
        <Box style={{ width: '27px', height: '27px' }}>
          <img
            alt="car"
            src={icon}
            style={{ width: '100%', height: '100%' }}
          />
        </Box>

        <Tooltip
          title={safeText}
          disableHoverListener={!isOverflow}
          arrow
        >
          <Typography
            ref={textRef}
            style={{
              fontSize: '12px',
              fontWeight: 'bold',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              width: '120px'
            }}
          >
            {safeText}
          </Typography>
        </Tooltip>
      </Box>

      {(row?.device_type === 'VGPS_2CAM' || row?.device_type === 'VGPS_4CAM') && (
        <Box
          key={index}
          style={{
            width: '12px',
            height: '7.67px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <img
            alt="camera"
            src={iconCameraLive}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </Box>
      )}
    </Box>
  );
};

export default React.memo(VehicleTableCell);
